import { render } from "./EditSpecial.vue?vue&type=template&id=3ad6c9a7&scoped=true"
import script from "./EditSpecial.vue?vue&type=script&lang=js"
export * from "./EditSpecial.vue?vue&type=script&lang=js"

import "./EditSpecial.vue?vue&type=style&index=0&id=3ad6c9a7&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad6c9a7"]])

export default __exports__